export default __webpack_public_path__ + "static/media/strimming.e9980424.jpg";